import { createFileRoute } from "@tanstack/react-router";
import { PriceBookDetailPage } from "@/components/inventory/PriceBookDetailPage";

export const Route = createFileRoute("/admin/_layout/inventory/price-books_/$id")({
  component: PriceBookDetailRoute,
});

function PriceBookDetailRoute() {
  const { id } = Route.useParams();
  return <PriceBookDetailPage priceBookId={id} />;
}
